<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{ $t('userprofile') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>

        <v-layout flex align-center justify-center class="mt-4">
          <v-col cols="12" md="12">
            <div style="text-align: center;">
              <v-avatar size="180" color="#2B76D1" class="mt-5" @click="pickFile">
                <span class="white--text headline">{{ shotName }}</span>
                <!-- <div class="dotted">
                  <img
                    :src="'data:image/png;base64,' + imageUrl"
                    class="circular--portrait"
                    v-if="imageUrl"
                  />
                </div> -->
                <!-- <v-text-field label="Select Image" @click="pickFile" v-model="imageName"></v-text-field> -->
                <!-- <input
                  type="file"
                  style="display: none"
                  ref="image"
                  accept="image/*"
                  @change="onFilePicked"
                /> -->
              </v-avatar>
            </div>

            <div style="text-align: center">
              <p class="mt-4">
                <b>Fusion Fusion</b>
              </p>
              <p>{{ username }}</p>
            </div>
          </v-col>
        </v-layout>
        <v-flex class="flex">
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
              <v-text-field placeholder="firstname" :label="$t('firstname')" v-model="firstName" :rules="[() => !!firstName || 'Required']" required></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field placeholder="lastname" :label="$t('lastname')" v-model="lastName" :rules="[() => !!lastName || 'Required']" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
              <v-text-field placeholder="email" :label="$t('email')" v-model="email" :rules="[rules.required, validateEmail(email)]"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field placeholder="phonenumber" :label="$t('phonenumber')" v-mask="mask" v-model="mobile" :rules="[rules.required, PhoneNumberValidation(mobile)]"></v-text-field>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <!-- <v-row v-show="flagChangePassword">
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
              <v-text-field
                ref="password"
                :label="$t('loginPwd')"
                :rules="[rules.required]"
                v-model="password"
                hide-details
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
              ></v-text-field>
              <small>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span :class="checkLengthPassword ? 'pass' : 'failed'">{{$t('checklengthcharacters')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkLowercaseLetter ? 'pass' : 'failed'">{{$t('checklowercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkUppercaseLetter ? 'pass' : 'failed'">{{$t('checkuppercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkNumber ? 'pass' : 'failed'">{{$t('checknumber')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkSpecialCharacter ? 'pass' : 'failed'">{{$t('checkspecialcharacter')}}</span>
                  </v-col>
                </v-row>
              </small>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                ref="confirmpassword"
                :label="$t('confirmPwd')"
                :rules="[rules.required]"
                v-model="confirmpassword"
                hide-details
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
              ></v-text-field>
              <small>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span :class="checkPasswordMatch ? 'pass' : 'failed'">{{ $t('checkPwdMatch') }}</span>
                  </v-col>
                </v-row>
              </small>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row> -->
          <div style="text-align: center">
            <v-btn color="#1976D2" class="mt-10 mr-2" style="width: 14rem" outlined 
            @click="changPasswordDialog = true; password = ''; confirmpassword = ''; checkLengthPassword = true; checkLowercaseLetter = true;
            checkUppercaseLetter = true; checkNumber = true; checkSpecialCharacter = true; checkPasswordMatch = true;">change password</v-btn>
            <v-btn color="#1976D2" class="mt-10 mr-2" @click="UpdateUser" style="width: 14rem" :loading="loading" :disabled="loading" outlined>
              <b>{{ $t('save') }}</b>
            </v-btn>
          </div>
 
          <br />
          <br />
          <br />
        </v-flex>
      </v-card>
    </v-container>
    <v-overlay :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>

    <!--dialog change password-->
    <v-dialog v-model="changPasswordDialog" width="600">
      <v-card>
        <v-card-title>Change Password</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field ref="password" :label="$t('loginPwd')" :rules="[rules.required]" v-model="password"
                 outlined dense hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                 @click:append="show1 = !show1"
                 :style="checkLengthPassword == true && 
                         checkLowercaseLetter == true &&
                         checkUppercaseLetter == true &&
                         checkNumber == true &&
                         checkSpecialCharacter == true ? 'margin-bottom: 26px;' : ''">
                  <template v-slot:append-outer>
                    <div style="position:absolute;">
                      <v-tooltip top max-width="40vw">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon text x-small style="position:absolute; top:0px; right:-6px"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t('loginPwd')}}</span>
                      </v-tooltip> 
                    </div>
                  </template>
                </v-text-field> 
                <small>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span :class="checkLengthPassword ? 'pass' : 'failed'">{{$t('checklengthcharacters')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkLowercaseLetter ? 'pass' : 'failed'">{{$t('checklowercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkUppercaseLetter ? 'pass' : 'failed'">{{$t('checkuppercaseletter')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkNumber ? 'pass' : 'failed'">{{$t('checknumber')}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span :class="checkSpecialCharacter ? 'pass' : 'failed'">{{$t('checkspecialcharacter')}}</span>
                  </v-col>
                </v-row>
                </small>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field ref="confirmpassword" :label="$t('confirmPwd')" :rules="[rules.required]" v-model="confirmpassword"
                 outlined dense hide-details :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                 @click:append="show2 = !show2"
                 :style="checkPasswordMatch == true ? 'margin-bottom: 26px;' : ''">
                  <template v-slot:append-outer>
                    <div style="position:absolute;">
                      <v-tooltip top max-width="40vw">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon text x-small style="position:absolute; top:0px; right:-6px"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t('confirmPwd')}}</span>
                      </v-tooltip> 
                    </div>
                  </template>
                </v-text-field>
                <small>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <span :class="checkPasswordMatch ? 'pass' : 'failed'">{{ $t('checkPwdMatch') }}</span>
                    </v-col>
                  </v-row>
                </small>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeChangePassword">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="saveChangePassword">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import checkPermission from '@/api/function.js';
import store from '../store';
import { mask } from 'vue-the-mask';
export default {
  name: 'UserProfile',
  mixins: [checkPermission],
  directives: {
    mask,
  },
  data: () => ({
    mask: '##########',
    show1: false,
    show2: false,
    dialog: false,
    loading: false,
    userList: [],
    shotName: '',
    passwordOld: '',
    username: '',
    password:'',
    confirmpassword: '',
    usertype: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    imageUrl: store.state.pathImage,
    imageName: '',
    imageFile: '',
    today: null,
    rules: {
      required: (value) => value === null || !!value || 'Required.',
    },

    checkLengthPassword: true,
    checkLowercaseLetter: true,
    checkUppercaseLetter: true,
    checkNumber: true,
    checkSpecialCharacter: true,
    checkPasswordMatch: true,
    statusFormatPassword: false,
    statusPassword: false,
    flagChangePassword: false,
    changPasswordDialog: false,
  }),

  watch: {
    password() {
      let self = this;
      if (self.password != null && self.password != undefined && self.password != '') {
        self.checkLengthPassword = self.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.password);
        self.checkNumber = /\d/.test(self.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.password);
        if (self.checkLengthPassword == true && self.checkLowercaseLetter == true && self.checkUppercaseLetter == true &&
            self.checkNumber == true && self.checkSpecialCharacter == true) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        } if (self.confirmpassword != null && self.password == self.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if(self.confirmpassword != null && self.confirmpassword.length > 0) {
          self.checkPasswordMatch = false;
        }
      } else {
        self.statusFormatPassword = false;
      }
    },
    confirmpassword() {
      let self = this;
      self.checkPasswordMatch = self.password == self.confirmpassword;
      if ((self.password != null && self.confirmpassword != null) &&
          (self.password == self.confirmpassword) && 
          self.checkLengthPassword == true && self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true && self.checkNumber == true && self.checkSpecialCharacter == true) {
        self.statusPassword = true;

      } else{
        self.statusPassword = false;
      }
    }
  },
  methods: {
    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || 'Please enter correct Phone Number';
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email) || 'Please enter correct Email';
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result.split(',')[1];
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },
    GetUserManagement() {
      let self = this;
      self.dialog = true;
      axios
        .post(`${self.url}EmployeeCom/GetEmployeeComAll`)
        .then(function (response) {
          self.userList = response.data.data;
          self.dialog = false;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    Get() {
      let self = this;
      self.dialog = true;
      self.$call.GetUserById(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.username = dataResponse.data.username;
            // self.password = self.decryptShiftData(dataResponse.data.password, 7);
            // self.confirmpassword = self.decryptShiftData(dataResponse.data.confirmpassword, 7);
            // self.passwordOld = self.decryptShiftData(dataResponse.data.password, 7);
            self.email = dataResponse.data.email;
            self.firstName = dataResponse.data.firstName;
            self.lastName = dataResponse.data.lastName;
            self.mobile = dataResponse.data.mobile;
            self.email = dataResponse.data.email;
            self.shotName = self.username.substring(0, 1).toUpperCase();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    UpdateUser() {
      let self = this;
      let emailvali = self.validateEmail(self.email);
      let phonevali = self.PhoneNumberValidation(self.mobile);
      if (emailvali == true && phonevali == true && self.firstName != '' && self.lastName != '') {
        try {
          self.loading = true;
          let tempUser = {
            username: self.username,
            password: self.flagChangePassword ? self.password : "",
            idcard: 0,
            prefixId: 0,
            firstName: self.firstName,
            lastName: self.lastName,
            mobile: self.mobile,
            eMail: self.email,
          };
          // axios
          //   .post(`${self.url}EmployeeCom/UpdateEmployeeCOM`, tempUser)
          //   .then(function(response) {
          //     if (response.data.status == 0) {
          //       alert(response.data.message);
          //       sessionStorage.setItem("firstName", self.firstName);
          //       sessionStorage.setItem("lastName", self.lastName);
          //       sessionStorage.setItem("email", self.email);
          //       sessionStorage.setItem("mobile", self.mobile);
          //       sessionStorage.setItem("pathImage", self.imageUrl);
          //       // sessionStorage.setItem("employeeID", self.employeeID);
          //       self.dialog = false;
          //       window.location.reload();
          //     }
          //   })
          //   .catch(function(error) {
          //     alert(error);
          //     self.dialog = false;
          //   });
          self.$call.UpdateUserProfile(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                Cookies.set('fullName', self.firstName + ' ' + self.lastName);
                store.state.fullName = self.firstName + ' ' + self.lastName;
                if (self.passwordOld != self.password) {
                  self.$call.ClearUserInfo();
                  this.$router.push('/login');
                }
              }
              self.loading = false;
            },
            (errorResource) => {
              self.loading = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, 'DeleteGroup');
        }
      } else {
        if (emailvali != true || phonevali != true) { 
          alert('Please Enter Correct Format!');
        } else if (self.firstName == '' || self.lastName == '' || self.password == '' || self.confirmpassword == '' ||
                   self.password == null || self.confirmpassword == null) {
          alert('Please Fill All The Fields!');
        }
        self.dialog = false;
      }
    },
    closeChangePassword() {
      let self = this;
      self.password = '';
      self.confirmpassword = '';
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.changPasswordDialog = false;
      self.show1 = false;
      self.show2 = false;
    },
    saveChangePassword() {
      try {
        let self = this;
        self.dialog = true;
        if (self.password != '' && self.confirmpassword != '' && self.password != null && self.confirmpassword != null &&
            self.password != undefined && self.confirmpassword != undefined && self.password == self.confirmpassword && 
            self.checkPasswordMatch == true && self.checkLengthPassword && self.checkLowercaseLetter && self.checkUppercaseLetter && 
            self.checkNumber && self.checkSpecialCharacter) {
            let temp = {
              password : self.password,
          };
          self.$call.SaveChangePassword(
            temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.$swal.fire({
                    icon: 'success',
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.password = '';
                  self.confirmpassword = '';
                  self.checkLengthPassword = true;
                  self.checkLowercaseLetter = true;
                  self.checkUppercaseLetter = true;
                  self.checkNumber = true;
                  self.checkSpecialCharacter = true;
                  self.checkPasswordMatch = true;
                  self.changPasswordDialog = false;
                  self.show1 = false;
                  self.show2 = false;
                }
                else
                {
                  self.$swal.fire({
                    icon: 'warning',
                    title: dataResponse.data.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                console.error(errorResource);
              }
            );
          } else {
            if ((self.password == '' || self.password == null || self.password == undefined) &&
            (self.confirmpassword != '' && self.confirmpassword != null && self.confirmpassword != undefined)) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Please fill Password!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if ((self.confirmpassword == '' || self.confirmpassword == null || self.confirmpassword == undefined) &&
            (self.password != '' && self.password != null && self.password != undefined)) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Please fill Confirm Password!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (self.password == null && self.confirmpassword == null) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Please fill Password and Confirm Password'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (!self.checkLengthPassword || !self.checkLowercaseLetter || !self.checkUppercaseLetter || !self.checkNumber ||
             !self.checkSpecialCharacter) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Please fill correct format!'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else if (self.password != self.confirmpassword && self.checkPasswordMatch == false) {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Password and Confirm Password do not match.Please fill correctly.'),
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              self.$swal.fire({
                icon: 'warning',
                title: self.$t('warning'),
                text: self.$t('Please fill all the fields!!!'),
                showConfirmButton: false,
                timer: 2000,
              });
            }
            self.changPasswordDialog = true;
            self.dialog = false;
          }
      } catch (error) {
        this.LogTrace(error, 'saveChangePassword');
      }
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split('');
      let decryptedChars = [];

      for (let i = 0; i < chars.length; i++) {
        let c = chars[i];

        if (/[a-zA-Z]/.test(c)) {
          let offset = c === c.toUpperCase() ? 'A'.charCodeAt(0) : 'a'.charCodeAt(0);
          c = String.fromCharCode(((c.charCodeAt(0) - offset - shift + 26) % 26) + offset);
        } else if (/[0-9]/.test(c)) {
          c = String.fromCharCode(((c.charCodeAt(0) - '0'.charCodeAt(0) - shift + 10) % 10) + '0'.charCodeAt(0));
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join('');
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.pass {
  display: none;
}

.failed {
  display: block;
  color: red;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
</style>
